import { DESCRIPTION_MAX_LENGTH } from '../../common/constants';
import { errorMap, transformNullish, zIsoDate } from '../../common/utils';
import { EntitySchema } from '../../common/utils/schema/EntitySchema';
import z, { string } from 'zod/v3';
import translations from './DataObjectCommentSchema.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, t } = i18nNsFactory('classifier-mapping-mutate');
addTranslations(translations);

export const DataObjectCommentSchema = EntitySchema.extend({
  valueDate: zIsoDate().nullable(),
  dataObjectVersionId: z.number().nullable(),
  versionNumber: z.number().nullable(),
  minorNumber: z.number().nullable(),
  versionStatus: string().nullable(),
  comment: transformNullish(z.string(), ''),
  confirm: z.boolean(),
});

export const DataObjectCommentValidFormDataSchema = z.object({
  id: z.number().nullable(),
  valueDate: zIsoDate().nullable(),
  dataObjectVersionId: z.number().nullable(),
  comment: z
    .string(
      errorMap((issue, _ctx) => {
        if (issue.code === z.ZodIssueCode.too_small) {
          return t('comment.required');
        } else if (issue.code === z.ZodIssueCode.too_big) {
          return t('comment.too_big', { max: issue.maximum });
        }
      }),
    )
    .min(1)
    .max(DESCRIPTION_MAX_LENGTH),
});

export const DataObjectCommentsValidFormDataSchema = z.object({
  comments: z.array(DataObjectCommentValidFormDataSchema),
});
